import {
  AGGREGATE_INVITATION,
  DELETE_AGGREGATE_FAILURE,
  DELETE_AGGREGATE_REQUEST,
  DELETE_AGGREGATE_SUCCESS,
  GET_AGGREGATE_FAILURE,
  GET_AGGREGATE_REQUEST,
  GET_AGGREGATE_SUCCESS,
  INSERT_AGGREGATE_FAILURE,
  INSERT_AGGREGATE_REQUEST,
  INSERT_AGGREGATE_SUCCESS,
  isAggregateActionType,
  LIST_AGGREGATES_FAILURE,
  LIST_AGGREGATES_ID_NAME_FAILURE,
  LIST_AGGREGATES_ID_NAME_NOT_MODIFIED,
  LIST_AGGREGATES_ID_NAME_REQUEST,
  LIST_AGGREGATES_ID_NAME_SUCCESS,
  LIST_AGGREGATES_NOT_MODIFIED,
  LIST_AGGREGATES_REQUEST,
  LIST_AGGREGATES_SUCCESS,
  RESET_AGGREGATE,
  UPDATE_AGGREGATE_FAILURE,
  UPDATE_AGGREGATE_REQUEST,
  UPDATE_AGGREGATE_SUCCESS,
  UPDATE_LIFECYCLE_FAILURE,
  UPDATE_LIFECYCLE_REQUEST,
  UPDATE_LIFECYCLE_SUCCESS,
} from '../../common/aggregate.types'
import {
  BrandingElementDto,
  BrandingElementType,
  CarParkTenantBrandingDto,
  InvitationCodeResponse,
  InvitationCodeResponseActionTypes,
  InvitationCodeResponseState,
} from './types'
import { RootState } from '../../store'

const initialState: InvitationCodeResponseState = {
  loadingList: false,
  loadingOne: false,
  inserting: false,
  inserted: false,
  updating: false,
  updated: false,
  error: null,
  aggregates: {
    values: [],
    totalCount: null,
    link: null,
    eTag: null,
  },
  idNames: {
    values: [],
    eTag: null,
  },
  aggregate: null,
  deleting: false,
  deleted: false,
  lifeCycleOnly: null,
  updatingLifeCycle: false,
  updateLifeCycleSuccess: false,
  updatedApplicationStatus: false,
  updatingApplicationStatus: false,
  applicationStatus: null,
  idOnly: {
    id: null,
  },
}

export function invitationReducer(
  state = initialState,
  action: InvitationCodeResponseActionTypes,
): InvitationCodeResponseState {
  // Guard against aggregate actions for another type.  Non aggregate actions and aggregate actions for another type we must ignore.
  if (isAggregateActionType(action.type) && action.payload.aggregateType !== AGGREGATE_INVITATION) {
    return state
  }

  switch (action.type) {
    case LIST_AGGREGATES_REQUEST:
    case LIST_AGGREGATES_ID_NAME_REQUEST:
      return {
        ...state,
        inserted: false,
        updated: false,
        loadingList: true,
        error: null,
        aggregate: null,
        deleted: false,
        updateLifeCycleSuccess: false,
      }
    case GET_AGGREGATE_REQUEST:
      return {
        ...state,
        inserted: false,
        updated: false,
        loadingOne: true,
        loadingList: false,
        error: null,
        aggregate: null,
        deleted: false,
      }
    case UPDATE_AGGREGATE_REQUEST:
    case INSERT_AGGREGATE_REQUEST:
      return {
        ...state,
        inserting: true,
        error: null,
      }
    case LIST_AGGREGATES_SUCCESS:
      return {
        ...state,
        loadingList: false,
        error: null,
        aggregates: action.payload.aggregates,
      }

    case LIST_AGGREGATES_NOT_MODIFIED:
      return {
        ...state,
        loadingList: false,
        error: null,
      }
    case LIST_AGGREGATES_ID_NAME_NOT_MODIFIED:
      return {
        ...state,
        loadingList: false,
        error: null,
      }
    case GET_AGGREGATE_SUCCESS:
      return {
        ...state,
        loadingList: false,
        loadingOne: false,
        error: null,
        aggregate: action.payload.aggregate,
      }
    case LIST_AGGREGATES_ID_NAME_SUCCESS:
      return {
        ...state,
        loadingList: false,
        error: null,
        idNames: action.payload.idNames,
      }
    case LIST_AGGREGATES_ID_NAME_FAILURE:
      return {
        ...state,
        loadingList: false,
        error: action.payload.error,
      }
    case UPDATE_AGGREGATE_SUCCESS:
      return {
        ...state,
        inserting: false,
        inserted: false,
        updated: true,
        error: null,
      }
    case INSERT_AGGREGATE_SUCCESS:
      return {
        ...state,
        inserting: false,
        inserted: true,
        updated: false,
        error: null,
        idOnly: action.payload.idOnly,
      }

    case LIST_AGGREGATES_FAILURE:
      return {
        ...state,
        loadingList: false,
        error: action.payload.error,
      }

    case GET_AGGREGATE_FAILURE:
      return {
        ...state,
        loadingOne: false,
        error: action.payload.error,
        aggregate: null,
      }
    case UPDATE_AGGREGATE_FAILURE:
    case INSERT_AGGREGATE_FAILURE:
      return {
        ...state,
        inserting: false,
        error: action.payload.error,
      }
    case DELETE_AGGREGATE_REQUEST:
      return {
        ...state,
        deleting: true,
        deleted: false,
        error: null,
      }
    case DELETE_AGGREGATE_SUCCESS:
      return {
        ...state,
        deleting: false,
        deleted: true,
        updatingLifeCycle: false,
        error: null,
      }
    case DELETE_AGGREGATE_FAILURE:
      return {
        ...state,
        deleting: false,
        deleted: false,
        updatingLifeCycle: false,
        error: action.payload.error,
      }

    case UPDATE_LIFECYCLE_REQUEST:
      return {
        ...state,
        updatingLifeCycle: true,
        error: null,
      }
    case UPDATE_LIFECYCLE_SUCCESS:
      return {
        ...state,
        updatingLifeCycle: false,
        updateLifeCycleSuccess: true,
        error: null,
      }
    case UPDATE_LIFECYCLE_FAILURE:
      return {
        ...state,
        updateLifeCycleSuccess: false,
        error: action.payload.error,
      }

    case RESET_AGGREGATE:
      return initialState
    default:
      return state
  }
}

export const selectBrandingLogo = (state: RootState) => {
  let invitation: InvitationCodeResponse | null = state.invitationReducer.aggregate
  if (invitation) {
    let branding: CarParkTenantBrandingDto | null = invitation.branding
    if (branding) {
      if (branding.elements.length > 0) {
        let brandingElement: BrandingElementDto | undefined = branding.elements.find(
          (row) => row.elementType === BrandingElementType.Image,
        )
        if (brandingElement) {
          return brandingElement.imageValue
        }
      }
    } else {
      return null
    }
  } else {
    return null
  }
}

export const selectBrandingColor = (state: RootState) => {
  let invitation: InvitationCodeResponse | null = state.invitationReducer.aggregate
  if (invitation) {
    let branding: CarParkTenantBrandingDto | null = invitation.branding
    if (branding) {
      if (branding.elements.length > 0) {
        let brandingElement: BrandingElementDto | undefined = branding.elements.find(
          (row) => row.elementType === BrandingElementType.Colour,
        )
        if (brandingElement) {
          return brandingElement.colourValue.value
        }
      }
    } else {
      return null
    }
  } else {
    return null
  }
}

export const selectSupportConfig = (state: RootState) => {
  let invitation: InvitationCodeResponse | null = state.invitationReducer.aggregate
  if (invitation) {
    return invitation.support
  } else {
    return null
  }
}

export const selectCompanyName = (state: RootState) => {
  let invitation: InvitationCodeResponse | null = state.invitationReducer.aggregate
  if (invitation) {
    return invitation.organisationName
  } else {
    return null
  }
}
